import { WithFormRewards } from 'v2/types';

export interface DistributionLinkForm extends WithFormRewards {
  key: string;
  maxUses: number;
  totalUses: number;
}

export const initialValues: DistributionLinkForm = {
  key: '',
  maxUses: 1,
  totalUses: 0,
  rewards: [],
};
